<template>
  <!-- record -->
  <div class="record">
    <div class="record-title">
      退货记录 <span>(共 {{historyList.length}} 条)</span>
    </div>
    <ul>
      <li v-for="item of historyList" :key="item.id">
        <i></i>
        <div class="order-num">
          退货单号：{{item.id}}
        </div>
        <div class="time">
          退货时间：{{item.createDate}}
        </div>
        <div>
          <router-link :to="'/drug/retreatdetail/'+item.id">
            <el-button type="text">查看详情</el-button>
          </router-link>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props: {
    historyList: {
      type: Array,
      default: [],
    }
  },
  methods: {
    
  },
  mounted() {
  }
}
</script>
<style lang="scss" scoped>
.record {
  margin-top: 40px;
  .record-title {
    color: #333333;
    span {
      color: #999999;
      font-size: 13px;
    }
  }
  ul {
    margin-top: 20px;
    li {
    height: 48px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #EEEEEE;
    i {
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 100%;
      background: #3F97FF;
      margin-right: 20px;
    }
    .order-num {
      display: block;
      width: 240px;
    }
    .time {
      flex: 1;
    }
    }
  }
}
</style>

